<div *ngIf="dataPropertyvente?.length">
    <h2>Acheter<span class="droite mx-3 float-end"><a  class="btn btn-primary" [routerLink]="['/biens-a-vendre/page/1']" title="">tous les biens à
                vendre</a></span></h2>
    <div class="row">
        <p *ngFor="let PropertyVente of dataPropertyvente" class="col-md-4"><a
                [routerLink]="['/biens-a-vendre/' + (PropertyVente?.type) + '/' + (PropertyVente?.ville) + '/' + PropertyVente?.property.pieces + (PropertyVente?.property.pieces < 2 ? '-piece' : '-pieces') + '/' + PropertyVente?.property.room + (PropertyVente?.property.room < 2 ? '-chambre' : '-chambres') + '/' + PropertyVente?.id]">{{PropertyVente?.ville}}
                <br> {{PropertyVente.type}}<span>{{PropertyVente.property.size}} m² - {{PropertyVente.property.pieces}}
                    pièces</span></a></p>
    </div>
    <br>
</div>
<div *ngIf="dataPropertylocation?.length">
    <h2>Louer <span class="droite mx-3 float-end"><a  class="btn btn-primary" [routerLink]="['/biens-a-louer/page/1']" title="">tous les biens à
                louer</a></span></h2>
    <div class="row">
        <p *ngFor="let PropertyLocation of dataPropertylocation" class="col-md-4"><a
                [routerLink]="['/biens-a-louer/' + (PropertyLocation?.type) + '/' + (PropertyLocation?.ville) + '/' + PropertyLocation?.property.pieces + (PropertyLocation?.property.pieces < 2 ? '-piece' : '-pieces') + '/' + PropertyLocation?.property.room + (PropertyLocation?.property.room < 2 ? '-chambre' : '-chambres') + '/' + PropertyLocation?.id]">{{PropertyLocation?.location}}
                <br> {{PropertyLocation.type}} <span>{{PropertyLocation.property.size}} m² -
                    {{PropertyLocation.property.pieces}} pièces</span></a></p>
    </div>
    <br>
</div>
<div *ngIf="departements?.length">
    <h2>Concessions</h2>
    <div class="row">
        <div class="col-md-12">
            <p *ngFor="let departement of departements">
                <a [routerLink]="['/nos-concessions/' + departement?.club[0].url_club + '/' + departement?.num]">
                    <span *ngIf="departement.nom">{{departement.nom}} ({{departement.num}})</span>
                    <span *ngIf="!departement.nom">{{departement.club[0].nom}} ({{departement.num}})</span>

                </a>
            </p>
        </div>
    </div>
</div>